import angular from 'angular';
import { isNil } from 'lodash';

module.exports = angular.module('common.filters.isNil', [])
.filter('isNil', () => isNil)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/isNil.js
 **/